export default __webpack_public_path__ + "static/facebook-49e67d43221b6bb1aa8624ebad043209.png";